import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';

export const VehicleSliderContainer = createComponent('div', {
  className: 'relative -mx-2xl w-screen sm:mx-0 sm:w-full'
});

export const Container = createComponent('div', {
  className:
    'mb-[35px] flex shrink-0 grow flex-col items-center gap-2xl'
});

export const PriceDetails = createComponent<
  ElementWithProps<{ show?: boolean }>
>('div', ({ show }) => ({
  className: cx(
    'absolute left-[47%] top-1/2 flex w-[145px] items-center gap-md rounded-md bg-[#0a6a3c] p-lg shadow-xl transition-opacity duration-300 ease-in-out',
    show ? 'opacity-100' : 'opacity-0'
  )
}));

export const Copy = createComponent('div', {
  className: 'flex flex-col items-start justify-center gap-0 p-0'
});

export const Payment = createComponent('span', {
  className: '!text-[12.15px] !leading-[18.9px] text-text-inverse t-body-xs'
});

export const Amount = createComponent('span', {
  className:
    '!text-[18.9px] !leading-[21.6px] !tracking-[-0.378px] text-text-inverse t-strong-sm'
});

export const Monthly = createComponent('span', {
  className: '!text-[10.8px] !leading-[13.5px] text-text-inverse t-strong-xs'
});

export const Card = createComponent('div', {
  className:
    'flex w-[162px] flex-col items-start gap-0 rounded-md p-0 shadow-md'
});

export const ImageContainer = createComponent('div', {
  className: 'flex h-[96.3px] flex-col items-start self-stretch'
});

export const Rectangle = createComponent('div', {
  className:
    'relative h-[96.3px] shrink-0 self-stretch rounded-t-md bg-background-muted-weak'
});

export const Vehicle = createComponent('div', {
  className:
    'absolute bottom-[0.3px] flex h-[88px] w-[162px] flex-col items-start gap-0 p-0'
});

export const VehicleImage = createComponent('div', {
  className: 'flex h-[88px] w-[162px] flex-col items-start gap-0 p-0'
});

export const Favorite = createComponent('div', {
  className: 'absolute right-[10.8px] top-[10.801px] h-[16.2px] w-[16.2px]'
});

export const Content = createComponent('div', {
  className:
    'flex h-[108px] flex-col items-start gap-0 self-stretch rounded-b-md border-b border-l border-r border-border-subtle bg-background-default p-xl'
});

export const Skeletons = createComponent('div', {
  className: 'flex flex-col items-start gap-[9px]'
});

export const Rectangle3 = createComponent('div', {
  className: 'h-[17.55px] w-[129.6px] rounded-sm bg-background-muted-subtle'
});

export const Rectangle4 = createComponent('div', {
  className: 'h-[17.55px] w-[84.375px] rounded-sm bg-background-muted-subtle'
});

export const Disclaimer = createComponent('div', {
  className: 'self-stretch text-center text-text-weak t-body-xs'
});
